import { Component } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-block-resources-list',
    templateUrl: './block-resources-list.component.html',
    styleUrl: './block-resources-list.component.scss',
    standalone: false,
})
export class BlockResourcesListComponent extends BlockAbstractComponent {
    get titleColor(): string | null {
        return this.block?.data?.titleColor || this.block?.data?.color || null;
    }

    get titleFontSize(): string | null {
        const size = this.block?.data?.titleFontSize ?? this.block?.data?.fontSize;
        if (!size && size !== 0) {
            return null;
        }
        return typeof size === 'number' ? `${size}px` : size || null;
    }

    get titleFontWeight(): string | number | null {
        const weight = this.block?.data?.titleFontWeight ?? this.block?.data?.fontWeight;
        if (weight === undefined || weight === null || weight === '') {
            return null;
        }
        return weight;
    }

    get linkColor(): string | null {
        return this.block?.data?.linkColor || this.block?.data?.linkFontColor || null;
    }

    get linkFontSize(): string | null {
        const size = this.block?.data?.linkFontSize;
        if (!size && size !== 0) {
            return null;
        }
        return typeof size === 'number' ? `${size}px` : size || null;
    }

    get linkFontWeight(): string | number | null {
        const weight = this.block?.data?.linkFontWeight;
        if (weight === undefined || weight === null || weight === '') {
            return null;
        }
        return weight;
    }
}
